import { render, staticRenderFns } from "./Wap_CZY005_Produce.vue?vue&type=template&id=bf04d272&scoped=true&"
import script from "./Wap_CZY005_Produce.vue?vue&type=script&lang=js&"
export * from "./Wap_CZY005_Produce.vue?vue&type=script&lang=js&"
import style0 from "./Wap_CZY005_Produce.vue?vue&type=style&index=0&id=bf04d272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf04d272",
  null
  
)

export default component.exports